/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_TranslationInputs */



/**
* | output |
* | --- |
* | "Import Translation" |
*
* @param {Import_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_translation = /** @type {((inputs?: Import_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer la traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzung importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入翻译")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポート翻訳")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tradução de Importação")
	return /** @type {LocalizedString} */ ("Import Translation")
});